export const triggerHapticFeedback = (
  type: "light" | "medium" | "heavy" | "rigid" | "soft"
) => {
  try {
    if (window.Telegram?.WebApp?.HapticFeedback?.impactOccurred) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred(type);
    } else if (navigator.vibrate) {
      const vibrationDuration = type === "heavy" ? 300 : type === "medium" ? 200 : 100;
      navigator.vibrate(vibrationDuration);
    }
  } catch {
    console.debug("Haptic feedback not available");
  }
};

export const HAPTIC_FEEDBACK = {
  LIGHT: "light" as const,
  MEDIUM: "medium" as const,
  HEAVY: "heavy" as const,
  RIGID: "rigid" as const,
  SOFT: "soft" as const,
} as const;
